import { ChartOptions, ChartLegendLabelItem } from 'chart.js';
import { LABEL_COLOR } from './constants';
import { customTooltip } from './tooltip.options';

export function getDefaultOptions(
  fontFamily: string,
  tooltipEl: HTMLElement,
): ChartOptions {
  return {
    scales: {
      yAxes: [
        {
          ticks: {
            callback: (label) => label,
            maxTicksLimit: 9,
            min: 0,
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            fontStyle: 'bold',
            fontSize: 14,
            fontFamily,
            fontColor: LABEL_COLOR,
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            min: 0,
            minRotation: 0,
            maxRotation: 0,
          },
          scaleLabel: {
            display: true,
            fontStyle: 'bold',
            fontSize: 14,
            fontFamily,
            fontColor: LABEL_COLOR,
          },
        },
      ],
    },
    elements: {
      point: {
        radius: 0,
        hoverRadius: 0,
      },
      line: {
        tension: 0,
      },
    },
    tooltips: {
      enabled: false,
      backgroundColor: '#ffffff',
      bodyFontColor: '#333333',
      bodyFontFamily: fontFamily,
      titleFontColor: '#333333',
      titleFontFamily: fontFamily,
      titleMarginBottom: 10,
      borderColor: 'rgba(127, 127, 127, .5)',
      borderWidth: 1,
      xPadding: 10,
      yPadding: 10,
      mode: 'index',
      intersect: false,
      position: 'nearest',
      custom: customTooltip.bind(null, tooltipEl),
    },
    legend: {
      align: 'center',
      position: 'bottom',
      labels: {
        padding: 10,
        boxWidth: 5,
        usePointStyle: true,
        fontSize: 11,
      },
      onClick(_, legendItem: ChartLegendLabelItem) {
        const index = legendItem.datasetIndex;
        const { chart } = this;
        const meta = chart.getDatasetMeta(index);
        meta.hidden = meta.hidden === null ? !chart.data.datasets[index].hidden : null;

        const allHidden = chart.config.data.datasets
          .map((_, index) => chart.getDatasetMeta(index))
          .map(({ hidden }) => hidden === true)
          .every((hidden) => hidden === true);
        if (allHidden) {
          tooltipEl.style.opacity = '0';
        }
        chart.update();
      },
    },
    maintainAspectRatio: false,
    hover: {
      animationDuration: 0,
    },
    animation: {
      duration: 0,
    },
    responsiveAnimationDuration: 0,
  };
}
